import { OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { getBillingInformationSelector } from '../billing.reducer';
import { Store } from '@ngrx/store';
import { UpdateBillingInformationAction } from '../billing.action';
import { markFormAsTouched } from '../../../lead-generation/shared/reactive-forms/forEachElementInForm';
import { BillingService } from '../billing.service';
import { AmplitudeService } from '../../../shared/services/amplitude.service';
import TAX_TYPE_DESCRIPTIONS from './tax.types';
var BillingInformationComponent = /** @class */ (function () {
    function BillingInformationComponent(fb, store, billingService, amplitudeService) {
        this.fb = fb;
        this.store = store;
        this.billingService = billingService;
        this.amplitudeService = amplitudeService;
        this.editMode = false;
    }
    BillingInformationComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.initForm();
        this.taxTypes = this.billingService.getTaxTypes();
        this.store.select(getBillingInformationSelector).subscribe(function (data) {
            _this.billingInformation = data;
            _this.fillData();
        });
    };
    BillingInformationComponent.prototype.initForm = function () {
        this.billingForm = this.fb.group({
            name: ['', Validators.required],
            taxType: [''],
            taxId: [''],
            line1: [''],
            line2: [''],
            postalCode: [''],
            city: [''],
            country: [''],
            state: [''],
            phone: [''],
            email: ['']
        });
        this.configureValidation();
    };
    Object.defineProperty(BillingInformationComponent.prototype, "isFormValid", {
        get: function () {
            return this.billingForm.valid;
        },
        enumerable: true,
        configurable: true
    });
    BillingInformationComponent.prototype.fillData = function () {
        var _this = this;
        Object.entries(this.billingInformation).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (_this.billingForm.controls.hasOwnProperty(key)) {
                _this.billingForm.controls[key].setValue(value || '');
            }
        });
    };
    BillingInformationComponent.prototype.edit = function () {
        this.amplitudeService.logEvent('Panel:Billing:EditInfo: Start');
        this.editMode = true;
    };
    BillingInformationComponent.prototype.cancel = function () {
        this.amplitudeService.logEvent('Panel:Billing:EditInfo: Cancel');
        this.editMode = false;
        this.fillData();
    };
    BillingInformationComponent.prototype.save = function () {
        this.amplitudeService.logEvent('Panel:Billing:EditInfo: Save');
        markFormAsTouched(this.billingForm);
        if (this.isFormValid) {
            this.store.dispatch(new UpdateBillingInformationAction(this.billingForm.getRawValue()));
            this.editMode = false;
        }
        else {
            this.amplitudeService.logEvent('Panel:Billing:EditInfo: Invalid form');
        }
    };
    BillingInformationComponent.prototype.getTaxTypeDescription = function (key) {
        return TAX_TYPE_DESCRIPTIONS[key];
    };
    BillingInformationComponent.prototype.configureValidation = function () {
        var _this = this;
        this.billingForm.get('taxType').valueChanges.subscribe(function (taxType) {
            var taxIdControl = _this.billingForm.get('taxId');
            taxIdControl.setValidators(taxType ? Validators.required : null);
            taxIdControl.updateValueAndValidity();
            var billingAddressControl = _this.billingForm.get('line1');
            billingAddressControl.setValidators(taxType ? Validators.required : null);
            billingAddressControl.updateValueAndValidity();
        });
    };
    return BillingInformationComponent;
}());
export { BillingInformationComponent };
